module.exports = __webpack_public_path__ + "static/1-dfbc7dbe93a44ae09eb8356fed055dc4.jpg";